import React from 'react';
import UserManagement from '../components/UserManagement';
import { useAuth } from '../contexts/AuthContext';

const UsersPage = () => {
  const { user } = useAuth();
  
  return <UserManagement currentUser={user} />;
};

export default UsersPage; 